//
//
//
//
//
//

export default {
  name: "App",
  mounted() {
    if (this._isMobile()) {
      if (localStorage.getItem("session_mobile") != null) {
        this.$router.push("/mobile_home");
      } else {
        this.$router.push("/mobile_login");
      }
    } else {
      if (localStorage.getItem("session_pc") != null) {
        this.$router.push("/home");
      } else {
        this.$router.push("/login");
      }
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue